import React from "react";
import {Form} from "antd";


export const FormCard = (props) => {
    return (
        <>
            <div className={props.className ? props.className : "cd-container"}>
                <div className="card cd-depth cd-round-edge border-0 my-5 p-md-4 ">
                    <div className="card-body">
                        <Form
                            // ref={formRef}.
                            name={"abroad-appForm-" + props.formName}
                            className="border-0 cd-form cd-form-theme-2 coder-form"
                            initialValues={{remember: true}}
                        >
                            {
                                !props.customHeader
                                    ? <div className="card-title h3">
                                        {props.headerLabel}
                                    </div>
                                    : <>
                                        {props.customHeader}
                                    </>
                            }
                            <>
                                {props.FormBody}
                            </>
                        </Form>
                    </div>
                </div>
            </div>
        </>
    )
}
